var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-uni-view',{staticClass:"tn-loading-class tn-loading",class:[
    ("tn-loading-" + _vm.mode),
    _vm.animation ? ("tn-loading-" + _vm.mode + "--animation") : ''
  ],style:([_vm.loadStyle])}):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }